import { scoreLevelRAGColour, scorePercentageRAGColour, SkillLevel, SkillPercentage } from '@keplerco/core';
import React from 'react';
import { useAppState } from '../../../overmind';
import { ISkillScoreProps } from './skill-score.models';

export function SkillScore({ score, noScoreText, noScoreColour, title, titleColour, labelColour, includeLabel, useRAGColours }: ISkillScoreProps) {
  const { companyVariables } = useAppState();

  function generateIndicatorColour() {
    if (!useRAGColours) return 'baby-blue';

    return companyVariables.useLevels ? scoreLevelRAGColour(score?.level ?? companyVariables.minLevel, companyVariables.minLevel, companyVariables.maxLevel) : scorePercentageRAGColour(score?.percentage ?? 0);
  }

  return companyVariables.useLevels ? (
    <SkillLevel
      level={score?.level ?? companyVariables.minLevel}
      minLevel={companyVariables.minLevel}
      maxLevel={companyVariables.maxLevel}
      noLevel={!score}
      noLevelText={noScoreText}
      noLevelColour={noScoreColour}
      title={title}
      titleColour={titleColour}
      dotColour={generateIndicatorColour()}
      labelColour={labelColour}
    />
  ) : (
    <SkillPercentage percentage={score?.percentage ?? 0} noPercentage={!score} noPercentageText={noScoreText} noPercentageColour={noScoreColour} title={title} titleColour={titleColour} barColour={generateIndicatorColour()} labelColour={labelColour} includeLabel={includeLabel} />
  );
}
